/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { IBvMenuItem } from 'volta/components/bv-menu';

import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { ComponentLike } from '@glint/template';
import type { BvMenuItemSignature } from '../item/index';

interface BvMenuSectionSignature {
  Args: {
    // Collection of action items
    section?: any;
    // Whether the parent action list has multiple sections
    hasMultipleSections?: boolean;
    onAnyItemAction?: (event: Event) => void;
  };
  Blocks: {
    default: [ComponentLike<BvMenuItemSignature>];
    title: [];
  };
}

export default class BvMenuSectionComponent extends Component<BvMenuSectionSignature> {
  @action
  onItemAction(item: IBvMenuItem, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    item.onClick?.(event);
    this.args.onAnyItemAction?.(event);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvMenu::Section': typeof BvMenuSectionComponent;
    'bv-menu/section': typeof BvMenuSectionComponent;
  }
}
